// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".group_list_title{height:48px;background-color:#2c405a;color:#fff;font-weight:900;font-size:20px;padding:0 17px 0 15px;box-sizing:content-box;display:flex;align-items:center;cursor:pointer}.group_list_title__elements_number{font-size:14px;color:#fff;font-weight:400;margin-left:6px;flex:1}", ""]);
// Exports
module.exports = exports;
